import type { Maybe } from '~/schema/types/generated'

type TOrder = 'ASC' | 'DESC'

export default function sortByPriority<T>(arr: (T & { priority?: Maybe<number> })[], order: TOrder = 'DESC') {
    if (!Array.isArray(arr)) {
        return arr
    }
    return arr.slice().sort((a, b) => {
        if (order === 'DESC') {
            return (b.priority || 0) - (a.priority || 0)
        } else {
            return (a.priority || 0) - (b.priority || 0)
        }
    })
}
